// src/common/typography/ControlLabelTypography.jsx
import {Typography} from '@mui/material';
import React from 'react';

const ControlLabelTypography = ({ children, className, ...props }) => {
    return (
        <Typography
            variant="subtitle1"
            className={className}
            sx={{mt: 1, mr: 1, fontFamily: "Gilroy-Regular", fontWeight: "bold", textWrap: "nowrap"}}
            {...props}
        >
            {children}
        </Typography>
    );
};

export default ControlLabelTypography;
